<template>
  <v-text-field
    id="search-service-field"
    v-bind="attrs"
    v-model="mainSearchBarStore.searchService"
    :bg-color="smAndUp ? 'transparent' : 'white'"
    :class="{ 'w-50': smAndUp }"
    :label="$t('heroSection.searchPlaceholder1')"
    :placeholder="$t('heroSection.searchPlaceholder1')"
    clearable
    flat
    hide-details
    prepend-inner-icon="mdi-magnify"
    single-line
    variant="solo"
    autocomplete="off"
    class="search-field"
    @update:focused="autocompleteServiceOnFocus"
    @update:model-value="mainSearchBarStore.autocompleteSearchServices"
  >
    <template #append-inner>
      <v-btn
        v-if="mainSearchBarStore.loadingServices"
        icon
        size="small"
        variant="text"
        :loading="mainSearchBarStore.loadingServices"
      ></v-btn>
    </template>
  </v-text-field>
  <v-menu v-model="menu" activator="#search-service-field" max-height="300px">
    <v-list
      v-if="0 < mainSearchBarStore.listAutocompleteService.length"
      :items="mainSearchBarStore.listAutocompleteService"
      @click:select="selectService"
      slim
      density="compact"
    >
    </v-list>
  </v-menu>
</template>
<script lang="ts" setup>
import { useMainSearchBarStore } from '@/store/search-page/mainSearchBarStore'
import { computed, ref, watch, useAttrs } from 'vue'
import { useDisplay } from 'vuetify'

const attrs = useAttrs()

const { smAndUp } = useDisplay()
const mainSearchBarStore = useMainSearchBarStore()
const autocompleteServiceOnFocus = event => {
  if (event) {
    mainSearchBarStore.autocompleteSearchServices(
      mainSearchBarStore.searchService,
    )
  }
}

watch(
  () => mainSearchBarStore.searchService,
  v => {
    mainSearchBarStore.alreadySearchWithSelectedCity = false
  },
)

function selectService(e) {
  mainSearchBarStore.searchService = e.id
}

const menu = ref(false)

const isMenuEmpty = computed(
  () => 0 === mainSearchBarStore.listAutocompleteService.length,
)

watch(
  () => mainSearchBarStore.searchLocation,
  (newval, _) => {
    const isFieldEmpty = !newval
    if (!isFieldEmpty && isMenuEmpty.value) {
      menu.value = true
    } else if (isMenuEmpty.value) {
      menu.value = false
    }
  },
)

watch(
  () => mainSearchBarStore.listAutocompleteService,
  (newVal, oldVal) => {
    if (0 < mainSearchBarStore.listAutocompleteService.length) {
      menu.value = true
    }
  },
)
</script>
<style scoped>
.search-field >>> input {
  opacity: 1 !important;
  color: black;
}
</style>
